import { createContext, useContext, type ReactNode } from "react";

/**
 * Lets the shared chat rail show the generated image under a GenerateImage
 * row without knowing Brand Media or the workshop media panel. The workshop
 * chat supplies the card; everywhere else nothing renders.
 */
export type GeneratedMediaRef = {
  id: string;
  fileName: string | null;
  aspectRatio: string | null;
};

export type GeneratedMediaCardRenderer = (media: GeneratedMediaRef) => ReactNode;

export const GeneratedMediaCardContext = createContext<GeneratedMediaCardRenderer | null>(
  null,
);

export function useGeneratedMediaCard() {
  return useContext(GeneratedMediaCardContext);
}

export const GENERATE_IMAGE_TOOL = "GenerateImage";

/** The image a GenerateImage call produced, read off its tool result. */
export function generatedMediaRef(event: {
  toolName: string;
  result?: unknown;
}): GeneratedMediaRef | null {
  if (event.toolName !== GENERATE_IMAGE_TOOL) return null;
  const result = event.result;
  if (!result || typeof result !== "object" || !("mediaId" in result)) return null;
  const id = String((result as { mediaId: unknown }).mediaId ?? "");
  if (!id) return null;
  const fileName =
    "fileName" in result ? String((result as { fileName: unknown }).fileName ?? "") : "";
  const aspectRatio =
    "aspectRatio" in result
      ? String((result as { aspectRatio: unknown }).aspectRatio ?? "")
      : "";
  return {
    id,
    fileName: fileName || null,
    aspectRatio: aspectRatio || null,
  };
}
